import script from "./TypeListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TypeListView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__